import React from "react";
import { Link } from "react-router-dom";
import CTAButton from "./CTAButton";
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

const Footer = () => (
  <div className="pt-12 md:pt-40" style={{
    background: "linear-gradient(180deg, #fefdfb 0%, #b3e5fc 20%, #d6fa70 50%)"
  }}>
    <footer className="container-custom">
      {/* Main Footer Content */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 py-16">
        {/* Logo & Brand Section */}
        <div className="flex flex-col justify-between items-start gap-4">
          <div className="text-3xl md:text-5xl font-bold tracking-tight text-black group-hover:opacity-75 transition-opacity">
            .BERCASTLE
          </div>
        </div>

        {/* Contact Information */}
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-4 text-xl">
            <a href="tel:+17276088386" className="flex items-center gap-3 text-slate-900 transition-colors">
              <span>(727) 608-8386</span>
            </a>
            <a href="mailto:hello@bercastle.com" className="flex items-center gap-3 text-slate-900 transition-colors">
              <span>hello@bercastle.com</span>
            </a>
            <div className="flex items-start gap-3 text-slate-900">
              <div className="leading-relaxed">
                <p>200 Central Ave, 4th Floor</p>
                <p>Saint Petersburg, FL 33701</p>
                <p>United States</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-4 text-xl">
            <Link className="text-xl text-slate-900 transition-colors" to="/privacy">
              Privacy Policy
            </Link>
            <Link className="text-xl text-slate-900 transition-colors" to="/terms">
              Terms &amp; conditions
            </Link>
          </div>
        </div>

      </div>
    </footer>
  </div>
);

export default Footer;
